/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    import IPagedResultsColumns = Meevo.Components.BaseClasses.IPagedResultsColumns;
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;
    import PriceLevelEnum = Meevo.Model.PriceLevelEnum;
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;
    import MassUpdateActionEnum = Meevo.Model.MassUpdateActionEnum;


    interface IPriceLevels {
        serviceId: string;
        priceLevel: number;
        price: number;
    }

    interface ISave {
        revertLocation: boolean,
        services: Array<any>,
        id?: string,
        scheduledDate?: Date,
        priceGroupId: any
    }

    interface IServicesMassUpdateCriteria {
        massUpdateAction: MassUpdateActionEnum,
        amount: number,
        isPercent: boolean,
        level: number,
        round: RoundPricesEnum | null;
    }

    interface IServiceSubCategory {
        catDisplayName: string
        hasActiveService: boolean
        languageId: number
        displayName: string
        id: string
        objectCreationType: number
        locationId: number
        homeLocationId: number
        objectState: number
        entityVersion: number
    }

    export class ServicesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        public disableCrud: boolean = true;
        public defaultFilterCriteria: any = {
            serviceCategoryId: undefined,
            serviceSubCategoryId: undefined,
            filter: undefined,
            includeActive: true,
            excludeScheduled: this.isSchedulePriceShow() ? true : undefined,
        };
        public filterCriteria: any = {...this.defaultFilterCriteria};
        public showFilteredItems: boolean = false;
        public isPreviewMassUpdate: boolean = false;
        public serviceCategory: any;
        public serviceSubCategory?: IServiceSubCategory;
        public amount: number;
        public massUpdateCriteria: IServicesMassUpdateCriteria = {
            massUpdateAction: MassUpdateActionEnum.Decrease,
            amount: 0,
            isPercent: false,
            level: null,
            round: null
        };
        public revertLocation: boolean = false;
        public scheduledDate?: Date;
        public isPriceManagement: boolean;
        public isAllServicesCoOwned: boolean = true;
        public disableSwitch = false;
        public setOptionSelected = false;
        public productSubCatCriteria = {
            catId: null
        };
        public displayPerPage = 24;

        private _priceLevelTranslate = [
            {
                id: null,
                displayName: 'LABEL_ALL'
            },
            {
                id: PriceLevelEnum.Level1,
                displayName: 'Level 1'
            },
            {
                id: PriceLevelEnum.Level2,
                displayName: 'Level 2'
            },
            {
                id: PriceLevelEnum.Level3,
                displayName: 'Level 3'
            },
            {
                id: PriceLevelEnum.Level4,
                displayName: 'Level 4'
            },
            {
                id: PriceLevelEnum.Level5,
                displayName: 'Level 5'
            },
            {
                id: PriceLevelEnum.Level6,
                displayName: 'Level 6'
            },
            {
                id: PriceLevelEnum.Level7,
                displayName: 'Level 7'
            },
            {
                id: PriceLevelEnum.Level8,
                displayName: 'Level 8'
            },
            {
                id: PriceLevelEnum.Level9,
                displayName: 'Level 9'
            }
        ];
        private _filterSortDefault = [
            {
                sortName: 'LABEL_SET',
                value: MassUpdateActionEnum.Set
            },
            {
                sortName: 'LABEL_INCREASE',
                value: MassUpdateActionEnum.Increase
            },
            {
                sortName: 'LABEL_DECREASE',
                value: MassUpdateActionEnum.Decrease
            }
        ];
        private _filterSortReset = {
            sortName: 'LABEL_RESET_TO_DEFAULT_PRICE',
            value: null
        };

        public filter = {
            levels: this._priceLevelTranslate,
            sort: [...this._filterSortDefault]
        };
        public pricingByText = 'LABEL_BASE_PRICING_TO';
        public businessInfoService: BusinessInfoDataService;
        public limitLevelsTo = 9;


        public defaultCriteria() {
            return this.filterCriteria;
        }

        constructor(protected params: Meevo.Model.ISectionParamsMarketPrice) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.isPriceManagement = !this.identityService.inCentralOfficeMode();
            this.isPrimarySection = false;
            this.businessInfoService = params.businessInfoService;

            this.getDefaultPriceLevels();
        }

        getDefaultPriceLevels() {
            this.dataService.customMethodData('api/tenant/businessinfo/settings', 'get', {}).then((el) => {
                this.limitLevelsTo = el.data.registerSettings.defaultPriceLevelsForService;
            });
        }


        public isSchedulePriceShow(): boolean {
            return this.params.contextService.getVisualState() === Model.MaintenanceFormVisualState.CustomSchedulePrice;
        }

        public get pagerBaseEndpoint(): string {
            if (!this.isPriceManagement) {
                return 'MarketPricing/Service/Preview';
            } else {
                return this.isSchedulePriceShow() ? 'PriceManagement/Queue/Service' : 'PriceManagement/Service';
            }
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.sectionModelRetrieved();
            this.takeBackup();
        }

        selected(subSectionContentKey?: string): void {
            if (this.isSchedulePriceShow()) {
                this.filterCriteria.excludeScheduled = true;
            }

            this.filterCriteria.priceGroupId = this.parentItemId;

            let data = this.params.contextService.sharedData;
            if (data && data.priceQueueItem) {
                this.applyDataForScheduled(data.priceQueueItem);
            } else {
                this.postCancel();
            }
        }

        /**
         * Restores the original model values which were stored at the time of load.
         * @returns {}
         */
        rollbackChanges(): void {
            _.extend(this.model, this.originalEntity);

            this.sectionModelRetrieved();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            if (this.isPriceManagement) {
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/PriceManagement/Service/CheckCoOwned/`, 'POST', {criteria: this.filterCriteria})
                    .then((res: { data: { isAllServicesCoOwned: boolean } }) => {
                        this.filter.sort = [...this._filterSortDefault];
                        this.isAllServicesCoOwned = res.data.isAllServicesCoOwned;

                        if (res.data.isAllServicesCoOwned && !this.identityService.isSingleLocation()) {
                            this.filter.sort.push(this._filterSortReset);
                        }
                    });
            }
            this.postCancel();
        }

        public pagerOnPageLoaded() {
            let pages = this.model.pages;
            let currentPage = pages[this.model.currentPage];

            _.each(currentPage, (element: any) => {
                let priceLevels = element.priceLevels;
                if (priceLevels.length === 0 && element.servicePricesFromQueue && element.servicePricesFromQueue.length > 0) {
                    priceLevels = element.servicePricesFromQueue;
                }

                _.each(priceLevels, (el: any) => {
                    if (Model.Guard.isNothing(el.price, false)) {
                        el.price = null;

                        if (this.isPriceManagement) {
                            _.each(element.tenantPrices, (tenantEl: any) => {
                                if (tenantEl.priceLevel === el.priceLevel) {
                                    el.price = tenantEl.price;
                                }
                            });
                        }
                    }

                    if (element.priceLevels !== 0 && element.servicePricesFromQueue && element.servicePricesFromQueue.length && !this.isPreviewMassUpdate) {
                        _.each(element.servicePricesFromQueue, (queueEl: any) => {
                            if (queueEl.priceLevel === el.priceLevel) {
                                el.priceBeforeQueue = el.price;
                                el.price = queueEl.price;
                            }
                        });
                    }
                });
                _.each(priceLevels, (el: IPriceLevels) => {
                    el.price = el.price || 0;
                })

                element.priceLevels = priceLevels.slice(0, this.limitLevelsTo);
            });

            this.disableSwitch = this.setOptionSelected;
            this.takeBackup();
        }

        public translateLevelPrice(priceId): string {
            let priceObj = _.find(this._priceLevelTranslate, function (level) {
                return level.id === priceId;
            });

            return priceObj.displayName;
        }

        public prevUnselected(): void {
            this.sectionEndpoint = '';
            this.clearSection();

            super.prevUnselected();
        }

        /**
         * Save
         * */
        public preSave(): any {

            if (this.isPriceManagement) {
                this.sectionEndpoint = '';
            } else {
                this.sectionEndpoint = 'Service';
            }

            if (this.isPreviewMassUpdate) {

                // Create object for save Mass update
                this.model = <IPagerModel>{
                    serviceCategoryId: this.filterCriteria.serviceCategoryId,
                    serviceSubCategoryId: this.filterCriteria.serviceSubCategoryId,
                    massUpdateAction: this.massUpdateCriteria.massUpdateAction,
                    amount: this.massUpdateCriteria.isPercent ? this.amount * 100 : this.amount,
                    isPercent: this.massUpdateCriteria.isPercent,
                    level: this.massUpdateCriteria.level,
                    revertLocation: this.revertLocation,
                    filter: this.filterCriteria.filter,
                    priceGroupId: this.filterCriteria.priceGroupId ? this.filterCriteria.priceGroupId : null,
                    round: this.massUpdateCriteria.round
                };
            } else {
                let currentPage = this.model.pages[this.model.currentPage];
                let originalEntity = this.originalEntity;
                let originalCurrentPage = originalEntity.pages[this.model.currentPage];
                let save: ISave = {
                    revertLocation: this.revertLocation,
                    priceGroupId: this.filterCriteria.priceGroupId ? this.filterCriteria.priceGroupId : null,
                    services: [
                        {
                            prices: []
                        }
                    ]
                };

                // Find changed items
                _.each(currentPage, (element: any, index) => {
                    let originalElement = originalCurrentPage[index];

                    _.each(element.priceLevels, (el: any, i) => {

                        if (el.price !== originalElement.priceLevels[i].price || Model.Guard.isSomething(el.priceBeforeQueue)) {
                            save.services[0].prices.push({
                                serviceId: el.serviceId,
                                priceLevel: el.priceLevel,
                                price: el.price === '' ? 0 : el.price,
                                oldPrice: originalElement.priceLevels[i].price,
                                shortcut: element.shortcut,
                                priceGroupPriceQueueTId: this.filterCriteria.priceGroupId ? this.filterCriteria.priceGroupId : null,
                            });
                        }
                    });
                });

                this.model = <IPagerModel>save;
            }

            if (this.scheduledDate) {
                this.model['scheduledDate'] = this.scheduledDate;
                this.model['priceGroupEntityTypeEnum'] = PriceGroupEntityTypeEnum.Service;
            }

            // Schedule Price Change
            if (this.filterCriteria.priceGroupId) {
                this.model['priceGroupId'] = this.filterCriteria.priceGroupId;
                this.model['priceGroupEntityTypeEnum'] = this.filterCriteria.priceGroupEntityTypeEnum;
                this.model['priceChangeStatusEnum'] = this.filterCriteria.priceChangeStatusEnum;
            }
        }


        public postAdd() {
            if (this.model && this.model['priceGroupId']) {
                this.applyDataForScheduled(this.model);
            }
        }

        /**
         * Clear data
         * */
        public postCancel(): void {
            this.isPreviewMassUpdate = false;

            this.filterCriteria.priceGroupId = this.parentItemId;
            this.filterCriteria.amount = null;
            this.filterCriteria.round = null;

            this.massUpdateCriteria.massUpdateAction = MassUpdateActionEnum.Set;
            this.massUpdateCriteria.isPercent = false;
            this.massUpdateCriteria.round = null;
            this.massUpdateCriteria.level = null;
            this.massUpdateCriteria.amount = null;
            this.amount = 0;

            this.setOptionSelected = true;
        }

        public clearSection() {
            this.postCancel();

            this.showFilteredItems = false;

            this.scheduledDate = null;

            this.serviceCategory = null;

            if (!this.serviceCategory) {
                this.serviceSubCategory = this.productSubCatCriteria.catId = null;
            }

            this.filterCriteria = {...this.defaultFilterCriteria};
        }

        public applyDataForScheduled(data) {
            this.scheduledDate = data.scheduleDate;
            this.filterCriteria.priceGroupEntityTypeEnum = data.priceGroupEntityTypeEnum;
            this.filterCriteria.priceChangeStatusEnum = data.priceChangeStatusEnum;
            this.filterCriteria.priceGroupId = data.priceGroupPriceQueueId ? data.priceGroupPriceQueueId : data.priceGroupId;
            this.filterCriteria.excludeScheduled = true;
        }

        public prepareSubCategories(response: Partial<IServiceSubCategory>[], request) {
            const allValueItem = response.some(({ id }) => id === null)

            if (!allValueItem && request.pageNumber === 0) {
                response.unshift({
                    id: null,
                    displayName: 'All',
                    catDisplayName: 'All',
                });
            }
        }

        public categoryFilterChanged() {
            const serviceCategoryId = this.serviceCategory && this.serviceCategory.id;

            this.filterCriteria.serviceCategoryId = serviceCategoryId;
            this.productSubCatCriteria.catId = serviceCategoryId;

            this.serviceSubCategory = null;
            this.serviceSubCategoryFilterChanged();
        }

        public serviceSubCategoryFilterChanged() {
            this.filterCriteria.serviceSubCategoryId = this.serviceSubCategory && this.serviceSubCategory.id;
        }

        public onLevelsChanged() {
            this.setOptionSelected = this.massUpdateCriteria.massUpdateAction === MassUpdateActionEnum.Set;

            if (this.setOptionSelected) {
                this.pricingByText = 'LABEL_BASE_PRICING_TO';
                this.massUpdateCriteria.isPercent = false;
                this.massUpdateCriteria.round = null;
                this.disableSwitch = true;
            } else {
                this.disableSwitch = false;
                this.pricingByText = 'LABEL_BASE_PRICING_BY';
            }
        }
    }
}
